import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useCommunityGuidelinesQuery } from 'Generated/graphql-types'

const CROSS_RESILIA_DOMAIN = '.resilia.com'

export const setCommunityCookie = ({
  agreedCommunityGuidelines,
}: {
  agreedCommunityGuidelines: boolean
}) => {
  const isResiliaDomain = window.location.host.includes(CROSS_RESILIA_DOMAIN)
  const domain = isResiliaDomain ? `domain=${CROSS_RESILIA_DOMAIN};` : ''

  const cookieValue = JSON.stringify({
    agreedCommunityGuidelines,
  })

  document.cookie = `community_agreements=${cookieValue};${domain}max-age=31536000`
}

export const useCommunityCookie = () => {
  const { isAuthenticated } = useAuth0()

  const { data, loading, error } = useCommunityGuidelinesQuery({
    fetchPolicy: 'no-cache',
    skip: !isAuthenticated,
  })

  const agreedCommunityGuidelines = loading
    ? undefined
    : Boolean(data?.communityGuidelines?.isAgreed)
  useEffect(() => {
    if (agreedCommunityGuidelines !== undefined) {
      setCommunityCookie({ agreedCommunityGuidelines })
    }
  }, [agreedCommunityGuidelines])

  return {
    loading,
    error,
  }
}
